<template>
  <div
    class="function-button"
    :class="{
      'is-rectangle': isRectangle,
      'left-style': isLeftColumn,
      'right-style': !isLeftColumn
    }"
    :style="{ height: height || defaultHeight }"
  >
    <span class="button-title">{{ title }}</span>
    <img :src="icon" :alt="title" class="button-icon"/>
  </div>
</template>

<script>
export default {
  name: 'FunctionButton',
  props: {
    // 按钮标题
    title: {
      type: String,
      required: true
    },
    // 图标URL
    icon: {
      type: String,
      required: true
    },
    // 是否为长方形按钮
    isRectangle: {
      type: Boolean,
      default: false
    },
    // 是否为左侧栏按钮
    isLeftColumn: {
      type: Boolean,
      default: false
    },
    // 跳转路由
    to: {
      type: String,
      default: ''
    },
    // 新增：按钮高度
    height: {
      type: String,
      default: null
    }
  },
  computed: {
    defaultHeight () {
      // 左侧140px，右侧84px
      return this.isLeftColumn ? '140px' : '84px'
    }
  }
}
</script>

<style scoped>
.function-button {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 150, 136, 0.1);
  transition: all 0.3s ease;
}

.function-button:hover {
  box-shadow: 0 4px 12px rgba(0, 150, 136, 0.2);
  transform: translateY(-2px);
}

/* 左侧栏按钮样式：垂直排列，文字在上方，图标在下方 */
.function-button.left-style {
  flex-direction: column;
  justify-content: flex-start;
  height: 140px;
  padding-top: 15px;
  background: linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%);
}

.function-button.left-style .button-title {
  font-size: 20px;
  font-weight: 700;
  color: #2e7d32;
  margin-bottom: 15px;
}

.function-button.left-style .button-icon {
  width: 80%;
  aspect-ratio: 2/1;
  object-fit: cover;
}

/* 右侧栏按钮样式：水平排列，文字在左侧，图标在右侧 */
.function-button.right-style {
  flex-direction: row;
  justify-content: space-between;
  height: 84px;
  padding-left: 20px;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
}

.function-button.right-style .button-title {
  font-size: 18px;
  font-weight: 700;
  color: #1b5e20;
}

.function-button.right-style .button-icon {
  width: 60px;
  height: 60px;
  margin-right: 20px;
  object-fit: cover;
}

/* 长方形按钮特殊样式 */
.function-button.is-rectangle {
  background: linear-gradient(135deg, #dcedc8 0%, #aed581 100%);
}
</style>
